import * as Yup from 'yup';
import moment from 'moment';
import createArea from './createAreaFormModel';
const {
  formField: {

    // DATOS AREA 
    name,
    description

  }

} = createArea;


export default [


  Yup.object().shape({ 
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),    
    [description.name]: Yup.string().required(`${description.requiredErrorMsg}`),
  })
  
];  

    